/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewWorkflowStepFunctionPublishedEventOnSuccess } from '../models/new-workflow-step-function-published-event-on-success';
import { WorkflowStepFunctionPublishedEventOnSuccess } from '../models/workflow-step-function-published-event-on-success';
import { WorkflowStepFunctionPublishedEventOnSuccessPartial } from '../models/workflow-step-function-published-event-on-success-partial';
import { WorkflowStepFunctionPublishedEventOnSuccessWithRelations } from '../models/workflow-step-function-published-event-on-success-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class WorkflowStepFunctionPublishedEventOnSuccessControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnSuccessControllerCount
   */
  static readonly WorkflowStepFunctionPublishedEventOnSuccessControllerCountPath = '/workflow-step-function-published-event-on-successes/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnSuccessControllerService.WorkflowStepFunctionPublishedEventOnSuccessControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnSuccessControllerFindById
   */
  static readonly WorkflowStepFunctionPublishedEventOnSuccessControllerFindByIdPath = '/workflow-step-function-published-event-on-successes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnSuccessControllerService.WorkflowStepFunctionPublishedEventOnSuccessControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<WorkflowStepFunctionPublishedEventOnSuccessWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>) => r.body as WorkflowStepFunctionPublishedEventOnSuccessWithRelations)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnSuccessControllerDeleteById
   */
  static readonly WorkflowStepFunctionPublishedEventOnSuccessControllerDeleteByIdPath = '/workflow-step-function-published-event-on-successes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnSuccessControllerService.WorkflowStepFunctionPublishedEventOnSuccessControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnSuccessControllerUpdateById
   */
  static readonly WorkflowStepFunctionPublishedEventOnSuccessControllerUpdateByIdPath = '/workflow-step-function-published-event-on-successes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: WorkflowStepFunctionPublishedEventOnSuccessPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnSuccessControllerService.WorkflowStepFunctionPublishedEventOnSuccessControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: WorkflowStepFunctionPublishedEventOnSuccessPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnSuccessControllerFind
   */
  static readonly WorkflowStepFunctionPublishedEventOnSuccessControllerFindPath = '/workflow-step-function-published-event-on-successes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnSuccessControllerService.WorkflowStepFunctionPublishedEventOnSuccessControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>>) => r.body as Array<WorkflowStepFunctionPublishedEventOnSuccessWithRelations>)
    );
  }

  /**
   * Path part for operation workflowStepFunctionPublishedEventOnSuccessControllerCreate
   */
  static readonly WorkflowStepFunctionPublishedEventOnSuccessControllerCreatePath = '/workflow-step-function-published-event-on-successes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewWorkflowStepFunctionPublishedEventOnSuccess
  }): Observable<StrictHttpResponse<WorkflowStepFunctionPublishedEventOnSuccess>> {

    const rb = new RequestBuilder(this.rootUrl, WorkflowStepFunctionPublishedEventOnSuccessControllerService.WorkflowStepFunctionPublishedEventOnSuccessControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkflowStepFunctionPublishedEventOnSuccess>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewWorkflowStepFunctionPublishedEventOnSuccess
  }): Observable<WorkflowStepFunctionPublishedEventOnSuccess> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<WorkflowStepFunctionPublishedEventOnSuccess>) => r.body as WorkflowStepFunctionPublishedEventOnSuccess)
    );
  }

}
